import React, { useEffect } from 'react';
import './campos-com-icones.component.scss';
import { Button, FormControlLabel, TextField } from '@mui/material';
import { useInput } from '../../hooks/useInput.hook';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete';
import { ItensComIconesModel } from '../../models/footer.model';
import { SalvarPainelService } from '../../services/salvar-painel.service';
import EscolherIconeComponent from '../escolher-icone/escolher-icone.component';

type CamposMenuProps = {
  setVal: (val: any) => void;
  removeItem: (id?: string) => void;
  itemIcones?: ItensComIconesModel;
  index?: number;
}

function CamposComIconesComponent(props: CamposMenuProps) {

  const { value: iconeInputText, bind: bindIconeInputText, setValue: setIconeInputText } = useInput(props.itemIcones?.icone);
  const { value: legendaInputText, bind: bindLegendaInputText, setValue: setLegendaInputText } = useInput(props.itemIcones?.legenda);

  SalvarPainelService.getSalvar().subscribe(() => {
    handleChangeItem();
  });

  const handleChangeItem = () => {
    props.setVal({
      icone: iconeInputText,
      legenda: legendaInputText,
      id: props.itemIcones?.id
    });
  };

  return (
    <section className="campos-com-icones">
      <div className="campo w50">
        <EscolherIconeComponent icone={iconeInputText} setVal={(val) => setIconeInputText(val)} />
      </div>

      <div className="campo w50">
        <TextField {...bindLegendaInputText} label="Legenda" />
      </div>

      <div className="bts">
        <Button className='bt remove' onClick={() => props.removeItem(props.itemIcones?.id)}><DeleteIcon /> Remover menu</Button>
      </div>
    </section>
  );
}

export default CamposComIconesComponent;
